import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import { Tooltip, Paper } from '@material-ui/core';

import MaterialTable from 'material-table';
import tapaStyles from "./screeningDetails.module.css";
import commonStyles from '../common/common.module.css';
import { KeyboardDatePicker, TimePicker } from '@material-ui/pickers';
import CalendarToday from '@material-ui/icons/CalendarToday';
import { PendingAwbs } from '../../models/Screening';


const styles = (theme: Theme) =>

  createStyles({
    red: {
      backgroundColor: 'red !important',
      color: 'white',
      fontSize: '10px',
      padding: '3px',
      borderRadius: '3px',
      margin: '0',
      cursor: 'pointer',
    },
    center: {
      textAlign: 'center',
      margin: 'inherit'
    },
    relative: {
      position: 'relative'
    },
    linkButton2: {
      background: 'white',
      border: 'none'
    },
    linkButton: {
      transform: 'rotate(140deg)',
      width: '20px',
      cursor: 'pointer'
    },
    awbActionsList: {
      display: 'flex',
      flexDirection: 'row',
      width: '95%',
      justifyContent: 'space-around'
    }
  });

interface rowAwb {
  id: number;
  awb: string;
  awb_code: string;
  awb_number: string;
  awb_ver: number;
  pieces: string;
  weight: string;
  org: string;
  dst: string;
  order_number?: string;
};

interface PendingScreeningAwbsProps {
  classes: any;
  screenAwb: (code: string, number: string, version: number, orderNumber?: string) => void;
  awbs: Array<PendingAwbs>;
  date: any;
  dateChange: (date: any) => void;
};

const pendingScreeningAwbs = (props: PendingScreeningAwbsProps) => {

  const { classes } = props;

  return (
    <div className= { `${ commonStyles.wrapper } ${ tapaStyles.wrapper }` }>
      <div className={ classes.center }>
        <KeyboardDatePicker
          autoOk
          label=''
          className={ `${classes.dateInput} ${classes.ipField}` }
          value={props.date}
          format={'DD MMM YYYY'}
          onChange={ (date: any) => props.dateChange(date) }
          InputProps={{
            className: classes.blue,
            classes: { input: classes.inputtextField },
          }}
          InputLabelProps={{
            className: classes.blue,
          }}
          inputVariant='outlined'
        />
      </div>
      
      <h3 className= { `${ commonStyles.header } ${ tapaStyles.header }` } >Pending Screenings</h3>

      <MaterialTable
        components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
        data={ props.awbs }
        columns={[

          {
            title: 'AWB', field: 'driver_name', render: (rowData: rowAwb) => {
              return `${rowData.awb_code}-${rowData.awb_number}`;
            },
          },
          { title: 'Origin', field: 'org' },
          { title: 'Dest', field: 'dst' },
          { title: 'Pcs', field: 'pieces' },
          {
            title: 'Weight',
            field: 'weight',
            render: (rowData: rowAwb) => {
              return `${rowData.weight}K`;
            },
          },
          { title: 'Order Number', field: 'order_number' },
          {
            title: 'Action',
            headerStyle: { textAlign: 'center' },
            cellStyle: { minWidth: '100px', textAlign: 'center' },
            render: (rowData: rowAwb) => {
              return (
                <span className={classes.awbActionsList}>
                  <Tooltip title="Screen AWB">
                    <div><p className={ props.classes.red } onClick={ () => props.screenAwb(rowData.awb_code, rowData.awb_number, rowData.awb_ver, rowData.order_number) }>SCR</p></div>
                  </Tooltip>
                </span>
              );
            },
          },
        ]}

        options={{
          paging: false,
          pageSize: 10,
          maxBodyHeight: '400px',
          headerStyle: {
            backgroundColor: 'var(--tbl_head_bkg)',
            color: 'var(--tbl_head_color)',
            zIndex: 2,
          },
          showTitle: false,
          pageSizeOptions: [15, 20],
          toolbar: false,
          sorting: false
        }}
      />
    </div>
  );

};

export default withStyles(styles)(pendingScreeningAwbs);
